import React, { Component } from 'react'
import { Button } from 'reactstrap'
import _ from 'lodash'

class Pagination extends Component {
  state = {
    pages: [],
    interval: 10
  }

  componentDidMount = () => {
    this.updatePages()
  }

  componentDidUpdate = pp => {
    if( this.props.metadata.pages !== pp.metadata.pages ) {
      this.updatePages()
    }
  }

  updatePages = () => {
    let tmp = []
    for( let i = 0 ; i < this.props.metadata.pages ; i++ ) {
      tmp.push( i + 1 )
    }
    this.setState({ pages: tmp })
  }

  render = () => {
    return (
      <div className="pt-5">
        {/* <p className="mb-1 small text-center">{ `Current Page: ${ this.props.metadata.currentPage } of ${ this.props.metadata.totalPages }` }</p> */}
        <div className="d-flex pt-1" style={{ justifyContent: 'center', alignItems: 'center' }}>
          <Button
            className="mr-1"
            color="primary"
            disabled={ this.props.metadata.page === 1 }
            onClick={() => {
              this.props.onChangePage( this.props.metadata.page - 1 )
            }}>Prev</Button>
          {
            this.state.interval > 10 && (
              <Button
                className="mr-1"
                onClick={() => {
                  let tmp = _.cloneDeep( this.state.interval )
                  this.setState({ interval: tmp - 10 })
                }}>
                ...
              </Button>
            )
          }
          {
            this.state.pages.map(( item ) => {
              if(( item > ( this.state.interval - 10 ) ) && ( item <= this.state.interval )) {
                return (
                  <Button
                    key={ `Pagination-${ item }` }
                    outline 
                    className="mr-1 border-0 btn-transition"
                    color="dark"
                    onClick={() => this.props.onChangePage( item )}
                    active={ item === this.props.metadata.page }>
                    { item }
                  </Button>
                )
              }
            })
          }
          {
            ( this.state.interval < this.props.metadata.pages ) && (
              <Button
                className="mr-1"
                onClick={() => {
                  let tmp = _.cloneDeep( this.state.interval )
                  this.setState({ interval: tmp + 10 })
                }}>
                ...
              </Button>
            )
          }
          <Button
            className="ml-1"
            color="primary"
            disabled={ this.props.metadata.page === this.props.metadata.pages }
            onClick={() => {
              this.props.onChangePage( this.props.metadata.page + 1 )
            }}>Next</Button>
        </div>
      </div>
    )
  }
}

export default Pagination